import React from "react";
import { Globe, Cloud, Server, Settings2, Layers, Shield } from "lucide-react";

const D_COLORS = {
  PENDING: { bg: "bg-slate-500/15", text: "text-slate-300", border: "border-slate-500/30" },
  VERIFYING: { bg: "bg-amber-500/15", text: "text-amber-300", border: "border-amber-500/30" },
  ACTIVE: { bg: "bg-emerald-500/15", text: "text-emerald-300", border: "border-emerald-500/30" },
  DNS_ERROR: { bg: "bg-rose-500/15", text: "text-rose-300", border: "border-rose-500/30" },
  SSL_ERROR: { bg: "bg-rose-500/15", text: "text-rose-300", border: "border-rose-500/30" },
  DISABLED: { bg: "bg-neutral-500/15", text: "text-neutral-300", border: "border-neutral-500/30" },
};

const S_COLORS = {
  NONE: { bg: "bg-slate-500/15", text: "text-slate-300", border: "border-slate-500/30" },
  PENDING: { bg: "bg-amber-500/15", text: "text-amber-300", border: "border-amber-500/30" },
  ISSUED: { bg: "bg-emerald-500/15", text: "text-emerald-300", border: "border-emerald-500/30" },
  RENEWED: { bg: "bg-teal-500/15", text: "text-teal-300", border: "border-teal-500/30" },
  EXPIRING_SOON: { bg: "bg-amber-500/15", text: "text-amber-300", border: "border-amber-500/30" },
  EXPIRED: { bg: "bg-rose-500/15", text: "text-rose-300", border: "border-rose-500/30" },
  FAILED: { bg: "bg-rose-500/15", text: "text-rose-300", border: "border-rose-500/30" },
};

const P_ICONS = {
  MANUAL: Settings2, CLOUDFLARE: Cloud, HOSTINGER: Server, CPANEL: Layers, PLESK: Layers, OTHER: Globe,
  LETS_ENCRYPT: Shield, EXISTING: Shield, CLOUDFLARE_ORIGIN: Cloud, CUSTOM: Shield,
};

export function DomainStatusBadge({ status }) {
  const key = String(status || "PENDING").toUpperCase();
  const c = D_COLORS[key] || D_COLORS.PENDING;
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-[10px] font-black uppercase tracking-wider ${c.bg} ${c.text} ${c.border}`}
      data-testid={`dom-status-${key.toLowerCase()}`}>
      {key}
    </span>
  );
}

export function SslStatusBadge({ status }) {
  const key = String(status || "NONE").toUpperCase();
  const c = S_COLORS[key] || S_COLORS.NONE;
  return (
    <span className={`inline-flex items-center gap-1.5 rounded-full border px-2 py-0.5 text-[10px] font-black uppercase tracking-wider ${c.bg} ${c.text} ${c.border}`}
      data-testid={`dom-ssl-${key.toLowerCase()}`}>
      {key}
    </span>
  );
}

export function ProviderBadge({ code, providers, kind }) {
  const Icon = P_ICONS[code] || Globe;
  const info = (providers || []).find(p => p.code === code);
  const stubMark = info && !info.ready ? " (stub)" : "";
  return (
    <span className="inline-flex items-center gap-1 text-xs text-white/80" data-testid={`dom-prov-${kind}-${code?.toLowerCase()}`}>
      <Icon size={12} className="text-cyan-300" /> {info?.label || code}{stubMark}
    </span>
  );
}
